namespace TabAurous.GetItemRateHelper {

    export function GetPurchaseRate(AttributeId: number, ListId : number) {

        let Rate = 0;
        let ServiceEndpoint = "/services/" + TabAurous.Common.GetItemRateService.baseUrl + "/GetPurchaseRate"

        $.ajax({
            type: "post",
            dataType: "json",
            async: false,
            url: ServiceEndpoint,
            data: {
                'AttributeId': AttributeId,
                'ListId': ListId
            },
            success: function (response) {

                if (response instanceof Object) {
                    var json = response;
                }
                else {
                    var json = $.parseJSON(response);
                }

                var output = json['result'];
                Rate = output;


            }.bind(this),
            error: function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                alert("Error! " + err);
            }

        });

        return Rate;

    }

    export function GetSalesRate(AttributeId: number, ListId: number) {

        let Rate = 0;
        let ServiceEndpoint = "/services/" + TabAurous.Common.GetItemRateService.baseUrl + "/GetSalesRate"

        $.ajax({
            type: "post",
            dataType: "json",
            async: false,
            url: ServiceEndpoint,
            data: {
                'AttributeId': AttributeId,
                'ListId': ListId
            },
            success: function (response) {

                if (response instanceof Object) {
                    var json = response;
                }
                else {
                    var json = $.parseJSON(response);
                }

                var output = json['result'];
                Rate = output;


            }.bind(this),
            error: function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                alert("Error! " + err);
            }

        });

        return Rate;

    }


    export function GetGetMetalRate(MetalTypeId: number) {

        let Rate;
        let ServiceEndpoint = "/services/" + TabAurous.Common.GetItemRateService.baseUrl + "/GetMetalRate";

        $.ajax({
            type: "post",
            dataType: "json",
            async: false,
            url: ServiceEndpoint,
            data: { 'MetalTypeId': MetalTypeId },
            success: function (response) {

                if (response instanceof Object) {
                    var json = response;
                }
                else {
                    var json = $.parseJSON(response);
                }

                var output = json['result'];
                Rate = output;


            }.bind(this),
            error: function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                alert("Error! " + err);
            }

        });

        return Rate;

    }

}
